$(document).ready(function () {
  $('body').on('click', '.popup-close', function (e) {
    $.fancybox.close();
  });
  $('.download-popup').each(function (index) {
    var $popup = $(this);
    var $form = $popup.find('form');
    var docName = $form.find('input[name="document_name"]').val();
    $form.on('submit', function (e) {
      e.preventDefault();
      $.post($form.attr('action'), $form.serialize(), function (data) {
        $.fancybox.close();
        $.fancybox.open(`<div class="message-popup"><p>Download link for <strong>${docName}</strong> has been sent to your e-mail address.</p><button class="btn btn--blue popup-close">OK</button></div>`);
      });
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/js/app.js
// module id = 0
// module chunks = 0